import {
  InstantAnswerBuilderFn,
  InstantAnswerContext,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { countryToISO } from "../../utils/countryToISO";
import { getCountryName } from "../../utils/getCountryName";
import { getShipFromCountryForBrand } from "../../utils/getShippingFromCountryForBrand";
import { isSWFAvailableInCountry } from "../../utils/isSWFAvailableInCountry";

export const SwfAvailability: InstantAnswerBuilderFn = (strictLocalize) => ({
  descriptionBuilder: (context) =>
    isSWFAvailableDescriptionBuilder(context, strictLocalize),
});

const isSWFAvailableDescriptionBuilder = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
) => {
  const shipFromCountry =
    context.brandOrder?.brand_order?.ship_from_address?.country ??
    getShipFromCountryForBrand(context.brand);
  const shipFromCountryISO = countryToISO(shipFromCountry);
  const shipFromCountryName = getCountryName(
    shipFromCountryISO,
    strictLocalize
  );

  return isSWFAvailableInCountry(shipFromCountryISO)
    ? [SWF_AVAILABLE_IN_COUNTRY(strictLocalize, shipFromCountryName)]
    : [SWF_NOT_AVAILABLE_IN_COUNTRY(strictLocalize, shipFromCountryName)];
};

const SWF_AVAILABLE_IN_COUNTRY = (
  strictLocalize: StrictLocalizeFunction,
  countryName?: string
) =>
  strictLocalize(
    {
      defaultMessage:
        "Ship with Faire is available in {countryFullyTranslatedSentence}.",
    },
    { countryFullyTranslatedSentence: countryName ?? "(unknown)" }
  );

const SWF_NOT_AVAILABLE_IN_COUNTRY = (
  strictLocalize: StrictLocalizeFunction,
  countryName?: string
) =>
  strictLocalize(
    {
      defaultMessage:
        "Ship with Faire is not available in {countryFullyTranslatedSentence}.",
    },
    { countryFullyTranslatedSentence: countryName ?? "(unknown)" }
  );
